{
  "enums": {
    "claimStatus": {
      "draft": "Draf",
      "submitted": "Dihantar",
      "accepted": "Diterima",
      "denied": "Ditolak",
      "paid": "Dibayar"
    },
    "chargeStatus": {
      "pending": "Menunggu",
      "unbilled": "Belum dibilkan",
      "posted": "Dipos",
      "billed": "Dibilkan",
      "adjusted": "Diselaraskan",
      "voided": "Dibatalkan"
    },
    "statementDelivery": {
      "print": "Cetak",
      "email": "E-mel",
      "both": "Cetak & E-mel",
      "mail": "Mel"
    },
    "statementStatus": {
      "generated": "Dijana",
      "sent": "Dihantar",
      "viewed": "Dilihat"
    },
    "denialStatus": {
      "new": "Baharu",
      "inReview": "Dalam Semakan",
      "appealing": "Membuat Rayuan",
      "resolved": "Diselesaikan",
      "writtenOff": "Dihapus Kira"
    },
    "denialPriority": {
      "low": "Rendah",
      "medium": "Sederhana",
      "high": "Tinggi"
    },
    "claimType": {
      "professional": "Profesional",
      "institutional": "Institusi",
      "dental": "Pergigian",
      "pharmacy": "Farmasi"
    },
    "paymentMethod": {
      "cash": "Tunai",
      "check": "Cek",
      "creditCard": "Kad Kredit",
      "debitCard": "Kad Debit",
      "bankTransfer": "Pindahan Bank",
      "digitalWallet": "Dompet Digital",
      "insurance": "Insurans"
    },
    "paymentSource": {
      "patient": "Pesakit",
      "insurance": "Insurans",
      "thirdParty": "Pihak Ketiga"
    }
  },
  "form": {
    "validation": {
      "patientIdRequired": "ID pesakit diperlukan",
      "encounterIdRequired": "ID pertemuan diperlukan",
      "payerIdRequired": "ID pembayar diperlukan",
      "chargeCodeRequired": "Kod caj diperlukan",
      "unitPriceRequired": "Harga seunit diperlukan",
      "amountRequired": "Jumlah diperlukan",
      "amountPositive": "Jumlah mesti lebih besar daripada sifar",
      "chargeSelectionRequired": "Pilih sekurang-kurangnya satu caj"
    }
  },
  "pages": {
    "statements": {
      "title": "Penyata Bil",
      "labels": {
        "dashboard": "Papan Pemuka",
        "patient": "Pesakit",
        "from": "Dari",
        "to": "Hingga",
        "batchGenerate": "Jana Kelompok",
        "previewStatement": "Pratonton Penyata",
        "generatePrint": "Jana & Cetak",
        "generateEmail": "Jana & E-mel",
        "printEmail": "Cetak & E-mel",
        "print": "Cetak",
        "email": "E-mel"
      },
      "placeholders": {
        "searchPatient": "Cari mengikut nama atau MRN..."
      },
      "aria": {
        "periodFrom": "Tempoh penyata dari",
        "periodTo": "Tempoh penyata hingga"
      },
      "table": {
        "header": {
          "statementHistory": "Sejarah Penyata",
          "patient": "Pesakit",
          "mrn": "MRN",
          "date": "Tarikh",
          "amount": "Jumlah",
          "delivery": "Penghantaran",
          "status": "Status"
        },
        "preview": {
          "modal": "Pratonton Penyata",
          "patientStatement": "Penyata Pesakit",
          "patient": "Pesakit:",
          "mrn": "MRN:",
          "statementDate": "Tarikh Penyata:",
          "period": "Tempoh:",
          "lineItemHeader": {
            "date": "Tarikh",
            "description": "Penerangan",
            "charges": "Caj",
            "payments": "Bayaran",
            "balance": "Baki"
          },
          "openingBalance": "Baki Permulaan",
          "totals": "Jumlah",
          "amountDue": "Jumlah Perlu Dibayar"
        }
      },
      "states": {
        "generating": "Menjana...",
        "loading": "Menjana pratonton...",
        "noPatients": "Tiada pesakit ditemui",
        "noStatementData": "Tiada data penyata tersedia",
        "loadingHistory": "Memuatkan sejarah...",
        "noStatementsGenerated": "Belum ada penyata dijana",
        "selectedPatientId": "ID pesakit dipilih: {{id}}"
      },
      "toast": {
        "generated": "Penyata dijana",
        "generatedError": "Gagal menjana penyata",
        "batchStarted": "Penjanaan kelompok dimulakan: {{count}} penyata dalam baris gilir",
        "batchError": "Gagal memulakan penjanaan kelompok"
      }
    },
    "claims": {
      "title": "Pengurusan Tuntutan",
      "labels": {
        "dashboard": "Papan Pemuka",
        "createClaim": "Cipta Tuntutan",
        "filters": "Penapis",
        "submit": "Hantar",
        "appeal": "Rayuan",
        "denialReason": "Sebab Penolakan",
        "expandHint": "Kembangkan tuntutan untuk melihat item baris di halaman tuntutan khusus.",
        "cancel": "Batal"
      },
      "filter": {
        "allStatuses": "Semua Status"
      },
      "placeholders": {
        "filterPayer": "Tapis mengikut pembayar..."
      },
      "aria": {
        "claimDateFrom": "Tarikh tuntutan dari",
        "claimDateTo": "Tarikh tuntutan hingga"
      },
      "table": {
        "header": {
          "claimNumber": "Tuntutan #",
          "patient": "Pesakit",
          "payer": "Pembayar",
          "total": "Jumlah",
          "status": "Status",
          "submitted": "Dihantar",
          "actions": "Tindakan"
        }
      },
      "modal": {
        "createClaim": "Cipta Tuntutan daripada Caj",
        "patientId": "ID Pesakit *",
        "payerId": "ID Pembayar *",
        "selectCharges": "Pilih Caj ({{selected}} dipilih)",
        "noBilledCharges": "Tiada caj belum dibilkan untuk pesakit ini"
      },
      "states": {
        "loading": "Memuatkan tuntutan...",
        "noClaims": "Tiada tuntutan ditemui",
        "creating": "Mencipta..."
      },
      "toast": {
        "created": "Tuntutan dicipta",
        "createdError": "Gagal mencipta tuntutan",
        "submitted": "Tuntutan dihantar",
        "submittedError": "Gagal menghantar tuntutan",
        "resubmitted": "Tuntutan dihantar semula untuk rayuan",
        "resubmittedError": "Gagal menghantar semula tuntutan",
        "patientPayerRequired": "Pesakit dan pembayar diperlukan",
        "chargeRequired": "Pilih sekurang-kurangnya satu caj"
      }
    },
    "charges": {
      "title": "Pengurusan Caj",
      "labels": {
        "dashboard": "Papan Pemuka",
        "newCharge": "Caj Baharu",
        "totalChargesPeriod": "Jumlah Caj (Tempoh)",
        "filters": "Penapis",
        "cancel": "Batal"
      },
      "filter": {
        "allStatuses": "Semua Status"
      },
      "placeholders": {
        "filterPatient": "Tapis mengikut pesakit..."
      },
      "aria": {
        "serviceDateFrom": "Tarikh perkhidmatan dari",
        "serviceDateTo": "Tarikh perkhidmatan hingga"
      },
      "table": {
        "header": {
          "date": "Tarikh",
          "patient": "Pesakit",
          "encounter": "Pertemuan",
          "code": "Kod",
          "description": "Penerangan",
          "qty": "Kuantiti",
          "unitPrice": "Harga Seunit",
          "total": "Jumlah",
          "status": "Status",
          "actions": "Tindakan"
        }
      },
      "actions": {
        "void": "Batalkan"
      },
      "modal": {
        "voidCharge": "Batalkan Caj",
        "voidChargeConfirm": "Batalkan caj {{code}} - {{description}} ({{amount}})?",
        "reason": "Sebab *",
        "reasonPlaceholder": "Masukkan sebab pembatalan..."
      },
      "states": {
        "loading": "Memuatkan caj...",
        "noCharges": "Tiada caj ditemui untuk tempoh ini",
        "voiding": "Membatalkan..."
      },
      "toast": {
        "voided": "Caj dibatalkan",
        "voidedError": "Gagal membatalkan caj",
        "reasonRequired": "Sebab diperlukan"
      }
    },
    "payments": {
      "title": "Pengeposan Pembayaran",
      "labels": {
        "dashboard": "Papan Pemuka",
        "uploadEraEob": "Muat Naik ERA/EOB",
        "postPayment": "Pos Pembayaran",
        "totalPaymentsPeriod": "Jumlah Pembayaran (Tempoh)",
        "filters": "Penapis",
        "cancel": "Batal"
      },
      "placeholders": {
        "filterPatient": "Tapis mengikut pesakit..."
      },
      "aria": {
        "paymentDateFrom": "Tarikh pembayaran dari",
        "paymentDateTo": "Tarikh pembayaran hingga"
      },
      "table": {
        "header": {
          "date": "Tarikh",
          "patient": "Pesakit",
          "claimNumber": "Tuntutan #",
          "amount": "Jumlah",
          "method": "Kaedah",
          "reference": "Rujukan",
          "postedBy": "Dipos Oleh"
        }
      },
      "modal": {
        "postPayment": "Pos Pembayaran",
        "patientId": "ID Pesakit *",
        "claimId": "ID Tuntutan (pilihan)",
        "claimIdHint": "Biarkan kosong untuk pembayaran tidak digunakan",
        "amount": "Jumlah *",
        "method": "Kaedah *",
        "referenceNumber": "Nombor Rujukan",
        "referenceHint": "Nombor cek, ID transaksi, dll.",
        "notes": "Nota"
      },
      "states": {
        "loading": "Memuatkan pembayaran...",
        "noPayments": "Tiada pembayaran ditemui untuk tempoh ini",
        "posting": "Mengepos..."
      },
      "toast": {
        "posted": "Pembayaran berjaya dipos",
        "postedError": "Gagal mengepos pembayaran",
        "patientAmountRequired": "Pesakit dan jumlah diperlukan",
        "validAmount": "Sila masukkan jumlah yang sah",
        "eraEobSoon": "Muat naik ERA/EOB akan datang"
      }
    },
    "chargeForm": {
      "title": "Cipta Caj",
      "labels": {
        "patientId": "ID Pesakit *",
        "encounterId": "ID Pertemuan *",
        "chargeCode": "Kod Caj *",
        "description": "Penerangan",
        "cptCode": "Kod CPT",
        "quantity": "Kuantiti *",
        "unitPrice": "Harga Seunit *"
      },
      "placeholders": {
        "chargeCode": "Cari master caj...",
        "cptCode": "Cari kod prosedur CPT..."
      },
      "buttons": {
        "cancel": "Batal",
        "create": "Cipta Caj"
      },
      "toast": {
        "created": "Caj dicipta",
        "createdError": "Gagal mencipta caj"
      }
    },
    "claimForm": {
      "title": "Cipta Tuntutan",
      "labels": {
        "patientId": "ID Pesakit *",
        "encounterId": "ID Pertemuan *",
        "payerId": "ID Pembayar *",
        "claimType": "Jenis Tuntutan *",
        "diagnosisCodes": "Kod Diagnosis",
        "selectCharges": "Pilih Caj ({{selected}} dipilih)",
        "notes": "Nota"
      },
      "placeholders": {
        "diagnosisCodes": "Kod ICD-10 dipisahkan koma (cth. J06.9, R05)"
      },
      "buttons": {
        "cancel": "Batal",
        "create": "Cipta Tuntutan"
      },
      "toast": {
        "created": "Tuntutan dicipta",
        "createdError": "Gagal mencipta tuntutan"
      }
    },
    "paymentForm": {
      "title": "Pos Pembayaran",
      "labels": {
        "patientId": "ID Pesakit *",
        "claimId": "ID Tuntutan",
        "amount": "Jumlah *",
        "method": "Kaedah Pembayaran *",
        "source": "Sumber",
        "referenceNumber": "Nombor Rujukan",
        "notes": "Nota"
      },
      "placeholders": {
        "claimId": "Pilihan — pautkan ke tuntutan",
        "reference": "Rujukan transaksi atau cek"
      },
      "buttons": {
        "cancel": "Batal",
        "post": "Pos Pembayaran"
      },
      "toast": {
        "recorded": "Pembayaran direkodkan",
        "recordedError": "Gagal merekod pembayaran"
      }
    },
    "denials": {
      "title": "Pengurusan Penolakan",
      "subtitle": "Jejak dan urus penolakan tuntutan bil",
      "placeholders": {
        "search": "Cari tuntutan..."
      },
      "filter": {
        "all": "Semua"
      },
      "checkbox": {
        "assignedToMe": "Ditugaskan kepada saya"
      },
      "table": {
        "header": {
          "claimNumber": "No. Tuntutan",
          "patient": "Pesakit",
          "denialCode": "Kod Penolakan",
          "denialReason": "Sebab Penolakan",
          "amount": "Jumlah",
          "daysRemaining": "Hari Berbaki",
          "status": "Status",
          "assignedTo": "Ditugaskan Kepada",
          "actions": "Tindakan"
        }
      },
      "actions": {
        "review": "Semak",
        "appeal": "Rayuan",
        "writeOff": "Hapus Kira",
        "cancel": "Batal"
      },
      "modal": {
        "appealReason": "Sebab Rayuan",
        "appealPlaceholder": "Terangkan sebab rayuan...",
        "submitAppeal": "Hantar Rayuan",
        "writeOffTitle": "Hapus Kira Penolakan",
        "writeOffConfirm": "Adakah anda pasti mahu menghapus kira tuntutan {{claimNumber}} sebanyak {{amount}}? Tindakan ini tidak boleh dibatalkan.",
        "writeOffButton": "Hapus Kira"
      },
      "states": {
        "loading": "Memuatkan penolakan...",
        "noDenials": "Tiada penolakan ditemui",
        "submitting": "Menghantar..."
      },
      "toast": {
        "updateError": "Gagal mengemas kini status penolakan",
        "movedToReview": "Tuntutan {{claimNumber}} dipindahkan ke semakan",
        "appealSubmitted": "Rayuan dihantar",
        "writtenOff": "Tuntutan {{claimNumber}} dihapus kira"
      }
    }
  },
  "__review_denialReason": "Backend payer-authored — Phase 9, do not translate",
  "__review_denialCode": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeDescription": "Backend payer-authored — Phase 9, do not translate",
  "__review_chargeCode": "Backend payer-authored — Phase 9, do not translate"
}
